/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////// A ) LOAD FOLLOWING FUNCTIONS IN HEADER
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

$(document).ready(function ($) {

	//	MMENU

	$('#mobilenav').mmenu({
		navbars: [{
			add: true,
			content: jQuery('.header-mobilemenu'),
			position: "top"
		}],
		slidingSubmenus: false,
		header: true,
		extensions: [
			"pageshadow",
			"pagedim-black",
            "fullscreen"
		],
		offCanvas: {
			position: "right"
		}

	});

	var closeMmenu = $("#mobilenav").data("mmenu");

	$("#close-mmenu").click(function () {
		closeMmenu.close();
	});


	//	LAZY IMAGES

	var allLazy = new LazyLoad();
	$('img.lazyload').on('load');	// AdjustNAVIGATION After Lazyload Images

	/*
	 //	WORKAROUND TO AVOID $ is not a function

	 When "$" is not an alias of jQuery: Aliasing the jQuery Namespace
	 When using another JavaScript library, we may wish to call $.noConflict() to avoid namespace difficulties. When this function is called, the $ shortcut is no longer available, forcing us to write jQuery each time we would normally write $. However, the handler passed to the .ready() method can take an argument, which is passed the global jQuery object. This means we can rename the object within the context of our .ready() handler without affecting other code:

	 SOURCE
	 http://mmenu.frebsite.nl/support/tips-and-tricks.html
	 http://api.jquery.com/ready/
	 */

});